<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/event">Eventos</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Novo evento</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <form @submit="save">
                    <div class="card shadow mb-4">
                        <!-- Card Header - Dropdown -->
                        <div class="card-header">
                            Configuração evento
                        </div>
                        <div class="card-body">

                            <div class="row mt-2">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label for="">Quando houver o evento de*</label>
                                    <multiselect v-model="event.type" :options="event_options"
                                        placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                        :deselect-label="'Clique para remover'" @select="handleSelectEvent">
                                        <template #noResult>
                                            Nenhum evento encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="row mt-2" v-if="event_client_status">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label for="">Quando o cliente assumir o status*</label>
                                    <multiselect v-model="event.status" :options="status_client"
                                        placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                        :deselect-label="'Clique para remover'">
                                        <template #noResult>
                                            Nenhum status encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-6 col-md-6 col-xs-6 col-sm-12">
                                    <label for="">Notificação por e-mail?</label>
                                    <multiselect v-model="email_multiselect" :options="email_options"
                                        :custom-label="activityWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleEmailSelect">
                                        <template #noResult>
                                            Nenhuma opção encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-6 col-md-6 col-xs-6 col-sm-12">
                                    <label for="">Notificação por whatsapp?<span tooltip="Whatsapp deve está conectado"> <i class="fa fa-info-circle red"></i></span></label>
                                    <multiselect v-model="whatsapp_multiselect" :options="whatsapp_options"
                                        :custom-label="activityWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleWhatsappSelect">
                                        <template #noResult>
                                            Nenhuma opção encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label for="">Notificar os usuários:</label>
                                    <multiselect v-model="user_multiselect" :options="users_options"
                                        :custom-label="userWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectUser">

                                        <template #noResult>
                                            Nenhum usuário encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="row mt-4" v-if="users_event_selected.length > 0">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label>Usuários a serem notificados</label>
                                    <div class="table-responsive">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Nome</th>
                                                    <th>E-mail</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(user, index) in users_event_selected" :key="index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ user.name }} </td>
                                                    <td>{{ user.email }} </td>
                                                    <td><button class="btn btn-danger" type="button"
                                                            @click="removeUserNotification(user)"><i
                                                                class="fa fa-trash"></i> Remover</button></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="card shadow mb-4">
                        <!-- Card Header - Dropdown -->
                        <div class="card-header">
                            Criação atividade
                        </div>
                        <div class="card-body">
                            <div class="row mt-2">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label for="">Criar atividade para o evento?</label>
                                    <multiselect v-model="activity_multiselect" :options="activity_options"
                                        :custom-label="activityWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleActivitySelect">
                                        <template #noResult>
                                            Nenhuma opção encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="row mt-2" v-if="this.event.create_activity">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label for="">Título da atividade*</label>
                                    <input type="text" class="form-control" placeholder="Título da atividade"
                                        v-model="event.activity_title">
                                </div>
                            </div>
                            <div class="row mt-2" v-if="this.event.create_activity">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label for="">Descrição da atividade*</label>
                                    <input type="text" class="form-control"
                                        placeholder="Ex: Enviar NF-e para o cliente XYZ"
                                        v-model="event.activity_description">
                                </div>
                            </div>
                            <div class="row mt-2" v-if="this.event.create_activity">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label for="">Quantos dias a atividade deve ser finalizada após sua
                                        criação?*</label>
                                    <input type="number" class="form-control" value="1" min="1"
                                        v-model="event.activity_deadline">
                                </div>
                            </div>
                            <div class="row mt-2" v-if="this.event.create_activity">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label for="">Usuários vinculados à atividade:</label>
                                    <multiselect v-model="user_multiselect" :options="users_options"
                                        :custom-label="userWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectUserActivity">

                                        <template #noResult>
                                            Nenhum usuário encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="row mt-4"
                                v-if="users_activity_selected.length > 0 && this.event.create_activity">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <label>Usuários para criação de atividades</label>
                                    <div class="table-responsive">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Nome</th>
                                                    <th>E-mail</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(user, index) in users_activity_selected" :key="index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ user.name }} </td>
                                                    <td>{{ user.email }} </td>
                                                    <td><button class="btn btn-danger" type="button"
                                                            @click="removeUserActivity(user)"><i
                                                                class="fa fa-trash"></i> Remover</button></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i>
                                        Cadastrar</button>
                                    <router-link to="/event" class="btn btn-danger ml-3"><i class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { notify } from '@kyvg/vue3-notification';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Multiselect from 'vue-multiselect'

export default {

    components: { Loading, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            user_multiselect: '',
            activity_multiselect: { type: false, value: 'Não' },
            email_multiselect: { type: true, value: 'Sim' },
            whatsapp_multiselect: { type: false, value: 'Não' },
            event_client_status: false,
            status_client: ['Aguardando cadastro domínio', 'Aguardando assinatura contrato', 'Aguardando parametrização domínio', 'Ativo', 'Inativo', 'Baixado', 'Inadiplente', 'Em distrato', 'Transferido'],
            event_options: ['Criação cliente', 'Atualização cliente', 'Alteração status cliente', 'Adição arquivo cliente', 'Vencimento certificado cliente', 'Nova receita', 'Receita vencida', 'Receita atualizada', 'Receita cancelada'],
            email_options: [{ type: true, value: 'Sim' }, { type: false, value: 'Não' }],
            whatsapp_options: [{ type: true, value: 'Sim' }, { type: false, value: 'Não' }],
            activity_options: [{ type: true, value: 'Sim' }, { type: false, value: 'Não' }],
            users_options: [],
            users_event_selected: [],
            users_activity_selected: [],
            event: {
                type: '',
                status: 'Ativo',
                email: true,
                whatsapp: false,
                create_activity: false,
                activity_title: '',
                activity_description: '',
                activity_deadline: 1
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.event.type != '' && this.event.type;
        }
    },
    mounted() {
        this.isLoading = false;
        const response_uses = this.getUsers();
        response_uses.then(() => {
            this.users_options = this.users.map(item => ({
                key: item.id,
                value: item.name + ' / ' + item.role,
                name: item.name,
                email: item.email
            }));
        });
    },
    methods: {
        onCancel() { },
        async getUsers() {
            this.isLoading = true;
            const response = api.get('/userListAll', { params: { 'no_client': true } })
                .then((response) => {
                    this.users = response.data.users;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },

        activityWithLang({ value }) {
            return value;
        },
        handleEmailSelect(option) {
            this.event.email = option.type;
        },
        handleWhatsappSelect(option) {
            this.event.whatsapp = option.type;
        },
        handleActivitySelect(option) {
            this.event.create_activity = option.type;
        },

        handleSelectEvent(option) {
            this.event.type = option;
            if (option == 'Alteração status cliente') {
                this.event_client_status = true;
            } else {
                this.event_client_status = false;
            }

        },

        handleSelectUser(option) {
            this.insertUserEvent(option);
        },

        handleSelectUserActivity(option) {
            this.insertUserActivityEvent(option);
        },

        userWithLang({ value }) {
            return value;
        },

        userList(key) {
            let user_list = false;
            this.users_event_selected.forEach(user => {
                if (user.key == key) {
                    user_list = true;
                }
            });
            return user_list;
        },
        userListActivity(key) {
            let user_list = false;
            this.users_activity_selected.forEach(user => {
                if (user.key == key) {
                    user_list = true;
                }
            });
            return user_list;
        },

        insertUserEvent(user) {
            if (!this.userList(user.key)) {
                this.users_event_selected.push({ 'key': user.key, 'name': user.name, 'email': user.email });
                this.user_multiselect = '';
            } else {
                notify({
                    title: "Informação",
                    text: user.name + " já está na lista a ser notificada do evento.",
                    type: 'info'
                });
                this.user_multiselect = '';
            }

        },

        insertUserActivityEvent(user) {
            if (!this.userListActivity(user.key)) {
                this.users_activity_selected.push({ 'key': user.key, 'name': user.name, 'email': user.email });
                this.user_multiselect = '';
            } else {
                notify({
                    title: "Informação",
                    text: user.name + " já está na lista de atividades.",
                    type: 'info'
                });
                this.user_multiselect = '';
            }

        },

        removeUserNotification(user_remove) {
            this.users_event_selected.forEach(user => {
                if (user.key == user_remove.key) {
                    this.users_event_selected = this.users_event_selected.filter(user => user.key !== user_remove.key);
                }
            });
        },

        removeUserActivity(user_remove) {
            this.users_activity_selected.forEach(user => {
                if (user.key == user_remove.key) {
                    this.users_activity_selected = this.users_activity_selected.filter(user => user.key !== user_remove.key);
                }
            });
        },

        save(event) {
            event.preventDefault();
            let error = false;
            if (this.users_event_selected.length < 1) {
                notify({
                    title: "Falha",
                    text: "Insira pelo menos um usuário para ser notificado quando o evento ocorrer!",
                    type: 'error'
                });
                error = true;
            } else if (this.event.create_activity) {
                if (this.event.activity_title == '') {
                    notify({
                        title: "Falha",
                        text: "Insira o título da atividade!",
                        type: 'error'
                    });
                    error = true;
                } else if (this.event.activity_description == '') {
                    notify({
                        title: "Falha",
                        text: "Insira a descrrição da atividade!",
                        type: 'error'
                    });
                    error = true;
                } else if (this.event.activity_deadline < 1) {
                    notify({
                        title: "Falha",
                        text: "Insira quantos dias a atividade deve ser finalizada após sua criação!",
                        type: 'error'
                    });
                    error = true;
                } else if (this.users_activity_selected < 1) {
                    notify({
                        title: "Falha",
                        text: "Insira pelo menos um usuário para criação da atividade informada!",
                        type: 'error'
                    });
                    error = true;
                }
            }

            if (!error) {
                this.enable_error_list = false;
                this.isLoading = true;
                const formData = new FormData();
                let user_notifications = JSON.stringify(this.users_event_selected);
                let user_events = JSON.stringify(this.users_activity_selected);
                formData.append('type', this.event.type);
                formData.append('status', this.event.status);
                formData.append('email', this.event.email);
                formData.append('whatsapp', this.event.whatsapp);
                formData.append('create_activity', this.event.create_activity);
                formData.append('activity_title', this.event.activity_title);
                formData.append('activity_description', this.event.activity_description);
                formData.append('activity_deadline', this.event.activity_deadline);
                formData.append('users_event', user_notifications);
                formData.append('users_activity', user_events);

                api.post('/event', formData)
                    .then(() => {
                        this.isLoading = false;
                        this.$notify({
                            title: "Sucesso",
                            text: "Evento cadastrado com sucesso!",
                            type: 'success'
                        });
                        this.users_event_selected = [];
                        this.users_activity_selected = [];
                        this.email_multiselect = { type: true, value: 'Sim' };
                        this.whatsapp_multiselect = { type: false, value: 'Não' };
                        this.activity_multiselect = { type: false, value: 'Não' };
                        this.event = {
                            type: '',
                            status: 'Ativo',
                            email: true,
                            whatsapp: false,
                            create_activity: false,
                            activity_title: '',
                            activity_description: '',
                            activity_deadline: 1
                        }
                    }).catch(error => {
                        this.isLoading = false;
                        if (error.status == 422) {
                            let response_errors = error.response.data.errors;
                            this.errors = response_errors;
                            this.enable_error_list = true;
                        }
                        handleRequestErrors(error.status, error);
                    })
            }

        }
    }
}
</script>

<style lang="scss" scoped></style>